import { type TranslationTree } from '@/i18n/types';

export const messages = {
  bannerAlt: 'Banner do evento',
  noDescription: 'Sem descrição.',
  when: 'Quando',
  until: 'até {{date}}',
  repeats: 'Repetição',
  where: 'Onde',
  link: 'Página do evento',
} satisfies TranslationTree;
